import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { productsReducer as products } from './products';
import { clientsReducer as clients } from './clients';
import { maintenancesReducer as maintenances } from './maintenances';
import { historyMaintenancesReducer as historyMaintenances } from './historyMaintenance';

import { statsReducer as stats } from './stats';

import { usersReducer as users } from './users';
import { errorsReducer as errors } from './errors';
import { sessionReducer as session } from './session';
import { shippingsReducer as shippings } from './shipping';
import { presencesReducer as presences } from './presence';
import { suppliersReducer as suppliers } from './suppliers';


import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import storage from 'redux-persist/lib/storage';

const reducer = combineReducers({
  session,
  products,
  maintenances,
  clients,
  stats,
  users,
  errors,
  shippings,
  presences,
  suppliers

});

export { productsActions } from './products';
export { maintenancesActions } from './maintenances';
export { historyMaintenancesActions } from './historyMaintenance';

export { clientsActions } from './clients';
export { statsActions } from './stats';
export { usersActions } from './users';
export { errorsActions } from './errors';
export { sessionActions } from './session';
export { shippingsActions } from './shipping';
export { presencesActions } from './presence';
export { suppliersActions } from './suppliers';





const persistConfig = {
  key: 'root',
  storage: storage,
};

const persistedReducer = persistReducer(persistConfig, reducer);

//export const store = createStore(persistedReducer);
//export const persistor = persistStore(store);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
export const persistor = persistStore(store);
